import { useState, useCallback, useEffect } from 'react';
import {
  getFilterTopic,
  IFilterTopicResponse,
  ICategoryItem,
} from '@op/services';
import { useCancelRequestHook } from './useCancelRequest';
import { gameInfoType } from '@op/types/common';

interface UseFilterTopicOptions {
  autoFetch?: boolean; // 是否自动请求
  defaultLoading?: boolean;
}

export const useFilterTopic = (
  filter?: gameInfoType,
  options?: UseFilterTopicOptions,
) => {
  const { autoFetch = true, defaultLoading = true } = options || {};
  const [data, setData] = useState<IFilterTopicResponse | null>(null);

  const { loading, error, wrapperCancelRequest } =
    useCancelRequestHook<IFilterTopicResponse>({
      clear: () => setData(null),
      defaultLoading,
    });

  const fetchData = useCallback((requestParams?: gameInfoType) => {
    const params = requestParams;
    return wrapperCancelRequest(getFilterTopic, params)
      .then(res => {
        setData(res);
        return res;
      })
      .catch(err => {
        console.error('获取分类筛选器失败:', err);
      });
  }, []);

  // 自动请求
  useEffect(() => {
    if (!autoFetch) return;
    fetchData(filter);
  }, [autoFetch, filter]);

  /**
   * 根据一级话题名称查找其下的所有二级话题名称
   * @param categoryName 一级话题名称（支持中英文）
   * @returns 二级话题名称数组，未找到时返回空数组
   */
  const getSubcategoriesByCategory = useCallback(
    (categoryName: string): string[] => {
      if (!data?.categories) return [];
      const targetName = categoryName.toLocaleLowerCase();
      const category = data.categories.find(
        (item: ICategoryItem) =>
          item.category_name_en.toLocaleLowerCase() === targetName,
      );
      return category
        ? category.subcategories.map(sub =>
            sub.sub_category_name_en.toLocaleLowerCase(),
          )
        : [];
    },
    [data],
  );

  return { data, loading, error, fetchData, getSubcategoriesByCategory };
};
